<template>
  <v-card outlined>
    <v-card-subtitle class="grey lighten-4 pa-3">Entities</v-card-subtitle>
    <v-list>
      <page-entity-item v-for="entity in entities" :key="entity.id" :entity="entity" :entity-types="entityTypes" />
    </v-list>
  </v-card>
</template>

<script>
// Components
import PageEntityItem from './page-entity-item'

export default {
  name: 'PageEntityList',
  components: { PageEntityItem },
  props: {
    entityTypes: {
      type: Array,
      required: true,
    },
    entities: {
      type: Array,
      required: true,
    },
  },
}
</script>
